export interface TrackingLegacyEvent {
  event: string;
  offerType?: string;
  offerProducts: string[];
  offerTotal: number | undefined;
  offerIsClient?: boolean;
}

export const LEGACY_EVENT_TYPES = {
  OFFER_UPDATE: 'offerUpdate',
  OFFER_COMPLETE: 'offerComplete',
};
